module.exports = __webpack_public_path__ + "static/media/priceHistory.6953a329.svg";